import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '../vue_widgets/product_form.vue'
import { plugin, defaultConfig } from '@formkit/vue'
import '@formkit/themes/genesis'

export default class extends Controller {
  connect(context) {
    if (document.documentElement.hasAttribute('data-turbo-preview')) return

    this.vue = createApp(App).use(plugin, defaultConfig({}))

    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
